import React, { useState, useEffect } from 'react';

import { ScrollArea } from "@/components/ui/scroll-area";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";
import { Calendar } from "@/components/ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

import { cn } from "@/lib/utils";

import { useRecoilState } from 'recoil';
import { tokenAtom } from '../../core/config/atoms';

import Moment from 'moment';
import * as XLSX from 'xlsx';
import { toast } from 'react-toastify';
import moment from 'moment';
import { motion } from "framer-motion";
import Lottie from 'lottie-react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import axios from 'axios';

import { Calendar as CalendarIcon } from "lucide-react";

import animBtnLoading from '../../assets/anim/anim-btnLoading.json';

import TopBar from 'core/widgets/ui/TopBar';

import { API_URL } from 'services/models/AppConstent';

import ServiceIntern from 'services/serviceIntern';
import ServiceUtility from 'services/serviceUtility';

const allowedExtensions = ["png", "jpeg"];

export default function PanelIntern() {
    const [token] = useRecoilState(tokenAtom);

    const [records, setRecords] = useState([]);

    const [record, setRecord] = useState({});
    const [filter, setFilter] = useState({});

    const [thubFile, setThubFile] = useState(null);
    const [thubPreview, setThubPreview] = useState(null);

    const [date, setDate] = useState({
        from: Moment().startOf('month').toDate(),
        to: Moment().toDate(),
    });

    const [query, setQuery] = useState('');

    const [pageSize, setPageSize] = useState(10);
    const [pageCurrent, setPageCurrent] = useState(0);
    const [pageTotal, setPageTotal] = useState(0);
    const [progress, setProgress] = useState(0);

    const [isDate, setIsDate] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    const [submit, setSubmit] = useState(false);
    const [isEdit, setIsEdit] = useState(false);

    const internService = new ServiceIntern();
    const utilService = new ServiceUtility();

    const formVSchema = Yup.object().shape({
        title: Yup.string().required('This information is required'),
        index: Yup.number().required('This information is required'),
        disc: Yup.string().required('This information is required'),
    });

    const { values, errors, touched, handleChange, handleSubmit, handleReset, setValues } = useFormik({
        initialValues: {
            title: '',
            index: 0,
            disc: ''
        },
        enableReinitialze: true,
        validationSchema: formVSchema,
        onSubmit: values => {
            if (isEdit) {
                if (thubFile !== null) {
                    setSubmit(true);
                    if (record.media.filename === "avatar.png") {
                        var formData = new FormData();
                        formData.append("path", 'intern');
                        formData.append("doc", thubFile);
                        edSubmit(formData, token, false);
                    } else {
                        var formData = new FormData();
                        formData.append("path", record.media.fileurl);
                        formData.append("doc", thubFile);
                        edSubmit(formData, token, true);
                    }
                } else {
                    let body = {
                        "uid": record._id,
                        "data": {
                            title: values.title,
                            index: values.index,
                            disc: values.disc
                        }
                    }
                    internService.updateIntern(body, token).then((res) => {
                        setSubmit(false);
                        if (res.status) {
                            toast.success("Intern updated!", { position: "top-right", autoClose: 2000, hideProgressBar: false, closeOnClick: true, progress: undefined, theme: "light" });
                            setIsOpen(false);
                            setIsEdit(false);
                            setRecord({});
                            loadData();
                            handleReset();
                            setThubFile(null);
                            setThubPreview(null);
                        } else {
                            toast.error('Server error please try again', { position: "top-right", autoClose: 2000, hideProgressBar: false, closeOnClick: true, progress: undefined, theme: "light" });
                        }
                    });
                }
            } else {
                if (thubFile !== null) {
                    setSubmit(true);
                    var formData = new FormData();
                    formData.append("path", 'intern');
                    formData.append("doc", thubFile);
                    fnSubmit(formData, token);
                } else {
                    let body = {
                        title: values.title,
                        index: values.index,
                        disc: values.disc,
                        media: {
                            "fileurl": "https://storage.googleapis.com/sche-web/assets/avatar.png",
                            "filename": "avatar.png",
                            "type": "image/jpeg",
                            "ext": "jpg"
                        },
                    }
                    internService.setIntern(body, token).then((res) => {
                        setSubmit(false);
                        if (res.status) {
                            toast.success("New intern added!", { position: "top-right", autoClose: 2000, hideProgressBar: false, closeOnClick: true, progress: undefined, theme: "light" });
                            setIsOpen(false);
                            loadData();
                            handleReset();
                            setThubFile(null);
                            setThubPreview(null);
                        } else {
                            toast.error('Server error please try again', { position: "top-right", autoClose: 2000, hideProgressBar: false, closeOnClick: true, progress: undefined, theme: "light" });
                        }
                    });
                }
            }
        },
    });

    const edSubmit = (data, token, isFile) => {
        (async function () {
            setProgress(0);
            var url = "";
            if (isFile) {
                url = `${API_URL}file/replaceFile`;
            } else {
                url = `${API_URL}file/uploadFile`;
            }

            var requestHeaders = {
                'Content-type': 'multipart/form-data',
                'Accept': '*/*',
                'Authorization': `bearer ${token}`,
            };

            const responseFile = await axios.post(url, data, {
                headers: requestHeaders,
                onUploadProgress: (progressEvent) => {
                    const progress = Math.round((progressEvent.loaded / progressEvent.total) * 100);
                    setProgress(progress);
                },
            });
            let resFile = responseFile.data.data;
            setProgress(0);

            let body = {
                "uid": record._id,
                "data": {
                    title: values.title,
                    index: values.index,
                    disc: values.disc,
                    media: resFile,
                }
            }
            internService.updateIntern(body, token).then((res) => {
                setSubmit(false);
                if (res.status) {
                    toast.success("Intern updated!", { position: "top-right", autoClose: 2000, hideProgressBar: false, closeOnClick: true, progress: undefined, theme: "light" });
                    setIsOpen(false);
                    setIsEdit(false);
                    setRecord({});
                    loadData();
                    handleReset();
                    setThubFile(null);
                    setThubPreview(null);
                } else {
                    toast.error('Server error please try again', { position: "top-right", autoClose: 2000, hideProgressBar: false, closeOnClick: true, progress: undefined, theme: "light" });
                }
            });
        })();
    }

    const fnSubmit = (data, token) => {
        (async function () {
            setProgress(0);
            var url = `${API_URL}file/uploadFile`;
            var requestHeaders = {
                'Content-type': 'multipart/form-data',
                'Accept': '*/*',
                'Authorization': `bearer ${token}`,
            };

            const responseFile = await axios.post(url, data, {
                headers: requestHeaders,
                onUploadProgress: (progressEvent) => {
                    const progress = Math.round((progressEvent.loaded / progressEvent.total) * 100);
                    setProgress(progress);
                },
            });
            let resFile = responseFile.data.data;
            setProgress(0);

            let body = {
                title: values.title,
                index: values.index,
                disc: values.disc,
                media: resFile,
            }
            internService.setIntern(body, token).then((res) => {
                setSubmit(false);
                if (res.status) {
                    toast.success("New intern added!", { position: "top-right", autoClose: 2000, hideProgressBar: false, closeOnClick: true, progress: undefined, theme: "light" });
                    setIsOpen(false);
                    loadData();
                    handleReset();
                    setThubFile(null);
                    setThubPreview(null);
                } else {
                    toast.error('Server error please try again', { position: "top-right", autoClose: 2000, hideProgressBar: false, closeOnClick: true, progress: undefined, theme: "light" });
                }
            });
        })();
    }

    const handleFileChange = (e) => {
        var { value, name } = e.target;
        let isError = false;

        const inputFile = e.target.files[0];
        const fileExtension = inputFile?.type.split("/")[1];

        if (!allowedExtensions.includes(fileExtension)) {
            alert.show("Only .png file format is allowed, please try again!", { type: 'error' });
            isError = true;
        }

        if (isError) {
            return;
        }

        setThubFile(inputFile);

        const reader = new FileReader();
        reader.onload = () => {
            setThubPreview(reader.result);
        };
        reader.readAsDataURL(inputFile);
    };

    const handleOnChange = (e) => {
        var { value, name } = e.target;
        switch (name) {
            case 'pageSize':
                setPageSize(value);
                break;
            case 'search':
                setQuery(value);
                break;
        }
    }

    const onDateChange = (event) => {
        setIsDate(true);
        setDate(event);
    }

    const downloadFile = ({ data, fileName, fileType }) => {
        const blob = new Blob([data], { type: fileType })
        const a = document.createElement('a')
        a.download = fileName
        a.href = window.URL.createObjectURL(blob)
        const clickEvt = new MouseEvent('click', {
            view: window,
            bubbles: true,
            cancelable: true,
        })
        a.dispatchEvent(clickEvt)
        a.remove()
    }

    const exportData = (type) => {
        (async function () {
            let body = {
                "filter": filter,
                "page": 0,
                "size": 0,
                "searchQuery": query,
                "startDate": isDate ? date.from.toISOString() : "",
                "endDate": isDate ? Moment(date.to).add(1, 'day').toDate().toISOString() : ""
            };
            var res = await internService.getAllIntern(body, token);
            var records = res.data.data;
            let items = [];
            records.forEach((item) => {
                items.push({
                    disc: item.disc,
                    title: item.title,
                    status: item.status,
                    createdAt: item.createdAt,
                });
            });

            if (type === "xlsx") {
                const worksheet = XLSX.utils.json_to_sheet(items);
                const workbook = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(workbook, worksheet, "Intern");
                XLSX.writeFile(workbook, "Interns.xlsx");
            } else {
                let headers = ['disc, title, status, createdAt'];
                let recordCsv = items.reduce((acc, record) => {
                    const { disc, title, status, createdAt } = record
                    acc.push([disc, title, status, createdAt].join(','))
                    return acc
                }, []);
                downloadFile({
                    data: [...headers, ...recordCsv].join('\n'),
                    fileName: 'Interns.csv',
                    fileType: 'text/csv',
                });
            }
        })();
    }

    const deleteRecord = (id, isFile, furl) => {
        if (isFile) {
            let resBody = {
                path: furl
            }
            utilService.deleteFile(resBody, token).then((res) => {
                let body = {
                    rid: id
                }
                internService.delIntern(body, token).then((res) => {
                    if (res['status']) {
                        loadData();
                    } else {
                        toast.error('Server error please try again', { position: "top-right", autoClose: 2000, hideProgressBar: false, closeOnClick: true, progress: undefined, theme: "light" });
                    }
                });
            })
        } else {
            let body = {
                rid: id
            }
            internService.delIntern(body, token).then((res) => {
                if (res['status']) {
                    loadData();
                } else {
                    toast.error('Server error please try again', { position: "top-right", autoClose: 2000, hideProgressBar: false, closeOnClick: true, progress: undefined, theme: "light" });
                }
            });
        }
    }

    const editRecord = (rec) => {
        setRecord(rec);
        setValues({ ...values, title: rec.title, index: rec.index, disc: rec.disc });
        setIsEdit(true);
        setIsOpen(true);
    }

    const pageChange = (pageValue) => {
        (async function () {
            let body = {
                "filter": filter,
                "page": pageValue,
                "size": parseInt(pageSize),
                "searchQuery": query,
                "startDate": isDate ? date.from.toISOString() : "",
                "endDate": isDate ? Moment(date.to).add(1, 'day').toDate().toISOString() : ""
            };
            var res = await internService.getAllIntern(body, token);
            if (res['status']) {
                setPageCurrent(res.data.currentPage);
                setPageTotal(res.data.totalPage);
                setRecords(res.data.data);
            } else {
                toast.error('Server error please try again', { position: "top-right", autoClose: 2000, hideProgressBar: false, closeOnClick: true, progress: undefined, theme: "light" });
            }
        })();
    }

    const loadData = () => {
        (async function () {
            let body = {
                "filter": filter,
                "page": 1,
                "size": parseInt(pageSize),
                "searchQuery": query,
                "startDate": isDate ? date.from.toISOString() : "",
                "endDate": isDate ? Moment(date.to).add(1, 'day').toDate().toISOString() : ""
            };
            var res = await internService.getAllIntern(body, token);
            if (res['status']) {
                setPageCurrent(res.data.currentPage);
                setPageTotal(res.data.totalPage);
                setRecords(res.data.data);
            } else {
                toast.error('Server error please try again', { position: "top-right", autoClose: 2000, hideProgressBar: false, closeOnClick: true, progress: undefined, theme: "light" });
            }
        })();
    }

    const nextPage = () => {
        if (pageCurrent < pageTotal) {
            pageChange(pageCurrent + 1);
        }
    }

    const prevPage = () => {
        if (pageCurrent > 1) {
            pageChange(pageCurrent - 1);
        }
    }

    useEffect(() => {
        loadData();
    }, []);

    useEffect(() => {
        loadData();
    }, [pageSize, query, date, filter]);

    return (
        <div className="w-full h-full py-3 px-3">
            {
                isOpen && <div className='overflow-y-auto overflow-x-hidden z-50 w-full h-modal md:h-full fixed top-0 left-0 bg-black bg-opacity-70'>
                    <div className='bg-white w-[600px] absolute right-0 min-h-screen p-[20px]'>
                        <ScrollArea>
                            <div className='px-4'>
                                <form onSubmit={handleSubmit}>
                                    <div className='flex items-center justify-between text-2xl'>
                                        <h1 className='font-sans font-medium text-gray-900'>Add Intern</h1>
                                        <span onClick={() => {
                                            setIsOpen(false);
                                            setIsEdit(false);
                                            setRecord({});
                                            loadData();
                                            handleReset();
                                            setThubFile(null);
                                            setThubPreview(null);
                                        }}><i className="las la-times text-xl text-gray-700 cursor-pointer"></i></span>
                                    </div>
                                    <hr className='my-4' />
                                    <div className="mb-8 space-y-4">

                                        <div className="w-full">
                                            <label className="block text-xs font-medium text-gray-700 font-mono">Intern Details<sup className="text-red-600">*</sup></label>
                                            <input type="text" id="title" onChange={handleChange} autoComplete="off" className="mt-1 p-2 block w-full h-9 bg-white text-sm border-gray-300 border rounded outline-1 outline-blue-200" placeholder="i.e. jhone deo, pHd" value={values.title} />
                                            {(errors.title && touched.title) && <p className='text-xs text-red-400 mt-1'>{errors.title}</p>}
                                        </div>

                                        <div className="w-full">
                                            <label className="block text-xs font-medium text-gray-700 font-mono">Intern Index<sup className="text-red-600">*</sup></label>
                                            <input type="text" id="index" onChange={handleChange} autoComplete="off" className="mt-1 p-2 block w-full h-9 bg-white text-sm border-gray-300 border rounded outline-1 outline-blue-200" placeholder="i.e. 0" value={values.index} />
                                            {(errors.index && touched.index) && <p className='text-xs text-red-400 mt-1'>{errors.index}</p>}
                                        </div>

                                        <div className="w-full">
                                            <label className="block text-xs font-medium text-gray-700 font-mono">Intern Summery<sup className="text-red-600">*</sup></label>
                                            <textarea type="text" id="disc" onChange={handleChange} autoComplete="off" className="mt-1 p-2 block w-full h-40 bg-white text-sm border-gray-300 border rounded outline-1 outline-blue-200" placeholder="i.e. Intern Summery" value={values.disc} />
                                            {(errors.disc && touched.disc) && <p className='text-xs text-red-400 mt-1'>{errors.disc}</p>}
                                        </div>

                                        {
                                            isEdit && <div className="mb-6">
                                                <label className="block mb-2 text-sm font-medium text-gray-600">Thumbnail File</label>
                                                {
                                                    (thubFile === null) && <div className="pl-3 pr-4 py-3 flex items-center justify-between text-sm bg-gray-100 rounded border mt-2">
                                                        <div className="w-0 flex-1 flex items-center">
                                                            <img src={record.media.fileurl} alt="Icon Template" className='w-10 h-10' />
                                                            <span className="ml-2 flex-1 w-0 truncate flex items-center">
                                                                {record.media.filename}&nbsp;
                                                                <i className="las la-link text-gray-400 text-lg"></i>
                                                            </span>
                                                        </div>
                                                        <div className="ml-4 flex-shrink-0">
                                                            <label className="relative cursor-pointer rounded-md font-medium text-indigo-600 font-mono">
                                                                <span>Replace</span>
                                                                <input type="file" className="sr-only" onChange={handleFileChange} />
                                                            </label>
                                                        </div>
                                                    </div>
                                                }
                                                {
                                                    thubFile !== null && <div className="pl-3 pr-4 py-3 flex items-center justify-between text-sm bg-gray-100 rounded border mt-2">
                                                        <div className="w-0 flex-1 flex items-center">
                                                            <img src={thubPreview} alt="Icon Template" className='w-10 h-10' />
                                                            <span className="ml-2 flex-1 w-0 truncate flex items-center">
                                                                {thubFile.name}&nbsp;
                                                                <i className="las la-link text-gray-400 text-lg"></i>
                                                            </span>
                                                        </div>
                                                        <div className="ml-4 flex-shrink-0">
                                                            <label className="relative cursor-pointer rounded-md font-medium text-indigo-600 font-mono">
                                                                <span>Replace</span>
                                                                <input type="file" className="sr-only" onChange={handleFileChange} />
                                                            </label>
                                                        </div>
                                                    </div>
                                                }
                                            </div>
                                        }

                                        {
                                            !isEdit && <div className="mb-6">
                                                <label className="block mb-2 text-sm font-medium text-gray-600">Thumbnail File</label>
                                                {
                                                    (thubFile === null) && <div className="mt-1 flex justify-center px-6 pt-5 pb-6 border-2 border-gray-300 border-dashed rounded-md">
                                                        <div className="space-y-1 text-center">
                                                            <svg className="mx-auto h-12 w-12 text-gray-400" stroke="currentColor" fill="none" viewBox="0 0 48 48" aria-hidden="true">
                                                                <path d="M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8 32l9.172-9.172a4 4 0 015.656 0L28 28m0 0l4 4m4-24h8m-4-4v8m-12 4h.02" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                                            </svg>
                                                            <div className="flex text-sm text-gray-600">
                                                                <label className="relative cursor-pointer bg-white rounded-md font-medium text-indigo-600 hover:text-indigo-500 focus-within:outline-none focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-indigo-500">
                                                                    <span>Upload a file</span>
                                                                    <input type="file" className="sr-only" onChange={handleFileChange} />
                                                                </label>
                                                                <p className="pl-1">or drag and drop</p>
                                                            </div>
                                                            <p className="text-xs text-gray-500">
                                                                .jpg or .png up to 2mb at 16:9 Ration
                                                            </p>
                                                        </div>
                                                    </div>
                                                }
                                                {
                                                    thubFile !== null && <div className="pl-3 pr-4 py-3 flex items-center justify-between text-sm bg-gray-100 rounded border mt-2">
                                                        <div className="w-0 flex-1 flex items-center">
                                                            <img src={thubPreview} alt="Icon Template" className='w-10 h-10' />
                                                            <span className="ml-2 flex-1 w-0 truncate flex items-center">
                                                                {thubFile.name}&nbsp;
                                                                <i className="las la-link text-gray-400 text-lg"></i>
                                                            </span>
                                                        </div>
                                                        <div className="ml-4 flex-shrink-0">
                                                            <label className="relative cursor-pointer rounded-md font-medium text-indigo-600 font-mono">
                                                                <span>Replace</span>
                                                                <input type="file" className="sr-only" onChange={handleFileChange} />
                                                            </label>
                                                        </div>
                                                    </div>
                                                }
                                            </div>
                                        }

                                        {
                                            submit && <div className='my-3'>
                                                <p className='text-xs text-gray-400'>Uploading....</p>
                                                <div className='w-full bg-gray-300 mt-1' style={{ height: '4px' }}>
                                                    <div style={{ width: `${progress}%`, transitionDuration: `4s` }} className="h-full transition-all bg-green-400"></div>
                                                </div>
                                            </div>
                                        }

                                    </div>
                                    <div className='w-full'>
                                        <button type="submit" className="w-full text-white bg-primeLight hover:bg-prime focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center flex items-center justify-center" disabled={submit}>
                                            {submit && <Lottie animationData={animBtnLoading} className="w-8 h-8" loop={true} />}
                                            {!submit && isEdit ? "UPDATE" : "ADD"}
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </ScrollArea>
                    </div>
                </div>
            }
            <ScrollArea className="w-full h-full py-3 px-3">
                <div className="grid grid-cols-12 grid-gap-2">
                    <div className="col-span-12 mt-2">
                        <div class="intro-y flex items-center justify-between h-10 border-b pb-4">
                            <h2 class="text-2xl font-medium font-serif truncate ml-2 text-prime">
                                Intern Master
                            </h2>
                            <div className='flex z-50'>
                                <button className="py-1 px-3 h-10 rounded-md bg-prime hover:bg-primeLight text-white mr-4" onClick={() => {
                                    setIsOpen(true);
                                }}><i className="las la-plus mr-2"></i> Add Record</button>
                                <TopBar />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-span-12 mt-4 px-2">
                    <div className="w-full shadow-md rounded-md border">
                        <table className="min-w-full divide-y divide-gray-200 px-4">
                            <thead className="bg-gray-50">
                                <tr className=''>
                                    <th scope="col" className="border-b border-gray-200" colSpan={4}>
                                        <div className='w-full grid grid-cols-12 gap-2'>
                                            <form className="items-center py-2 col-span-11 px-2 grid grid-cols-12 gap-2">
                                                <div className='col-span-3 flex'>
                                                    <Popover>
                                                        <PopoverTrigger asChild>
                                                            <Button id="date" variant={"outline"}
                                                                className={cn(
                                                                    "w-[300px] justify-start text-left font-normal",
                                                                    !date && "text-muted-foreground"
                                                                )}
                                                            >
                                                                <CalendarIcon className="mr-2 h-4 w-4" />
                                                                {date?.from ? (
                                                                    date.to ? (
                                                                        <>
                                                                            {Moment(date.from).format('MMM DD, yyyy')} -{" "}
                                                                            {Moment(date.to).format('MMM DD, yyyy')}
                                                                        </>
                                                                    ) : (
                                                                        Moment(date.from).format('MMM DD, yyyy')
                                                                    )
                                                                ) : (
                                                                    <span>Pick a date</span>
                                                                )}
                                                            </Button>
                                                        </PopoverTrigger>
                                                        <PopoverContent className="w-auto p-0" align="start">
                                                            <Calendar
                                                                initialFocus
                                                                mode="range"
                                                                defaultMonth={date?.from}
                                                                selected={date}
                                                                onSelect={onDateChange}
                                                                numberOfMonths={2}
                                                            />
                                                        </PopoverContent>
                                                    </Popover>
                                                </div>
                                                <div className='w-full flex col-span-9 items-center'>
                                                    <div className='w-[80px]'>
                                                        <p>Search :</p>
                                                    </div>
                                                    <input type="text" value={query} onChange={handleOnChange} name='search' placeholder="Search by intern." className="w-full h-10 px-4 font-sans text-sm outline-none rounded border" />
                                                </div>
                                            </form>
                                            <div className='col-span-1 flex items-center'>
                                                <DropdownMenu>
                                                    <DropdownMenuTrigger>
                                                        <button className="w-full py-1 px-2 h-10 rounded-md bg-prime hover:bg-primeLight text-white mr-4"><i className="las la-file-download mr-2"></i> Export </button>
                                                    </DropdownMenuTrigger>
                                                    <DropdownMenuContent>
                                                        <div
                                                            className='bg-white shadow-md rounded-md absolute' style={{ top: '0px', left: '-64px' }}>
                                                            <div>
                                                                <ul className='flex flex-col items-start p-2'>
                                                                    <DropdownMenuItem>
                                                                        <li className="w-40 cursor-pointer p-2 rounded-md" onClick={() => {
                                                                            exportData('xlsx');
                                                                        }}>
                                                                            <div className='flex items-center text-base'>
                                                                                <p className="text-sm font-serif ml-2 font-normal">Export to .xlsx</p>
                                                                            </div>
                                                                        </li>
                                                                    </DropdownMenuItem>
                                                                    <DropdownMenuItem>
                                                                        <li className="w-40 cursor-pointer p-2 rounded-md" onClick={() => {
                                                                            exportData('csv');
                                                                        }}>
                                                                            <div className='flex items-center text-base'>
                                                                                <p className="text-sm font-serif ml-2 font-normal">Export to .csv</p>
                                                                            </div>
                                                                        </li>
                                                                    </DropdownMenuItem>
                                                                </ul>
                                                            </div>
                                                        </div>
                                                    </DropdownMenuContent>
                                                </DropdownMenu>
                                            </div>
                                        </div>
                                    </th>
                                </tr>
                                <tr>
                                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer">
                                        Summery
                                    </th>
                                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer">
                                        Index
                                    </th>
                                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer">
                                        Created At
                                    </th>
                                    <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer"></th>
                                </tr>
                            </thead>
                            <tbody className="bg-white divide-y divide-gray-200">
                                {
                                    records.length !== 0 && records.map((reco, index) => {
                                        return <tr className="hover:bg-gray-100" key={index}>
                                            <td className="px-6 py-4">
                                                <span className="inline-flex text-sm leading-5 font-semibold text-gray-900">
                                                    <div className='flex'>
                                                        <img src={reco.media.fileurl} alt='Banner image' className='w-[180px] object-cover border rounded' />
                                                        <div className='ml-1'>
                                                            <div className='text-sm'>{reco.disc}</div>
                                                        </div>
                                                    </div>
                                                </span>
                                            </td>
                                            <td className="px-6 py-4 whitespace-nowrap">
                                                <div className="text-sm text-gray-800">
                                                    {reco.index}
                                                </div>
                                            </td>
                                            <td className="px-6 py-4 whitespace-nowrap">
                                                <div className="text-sm text-blue-600">
                                                    {moment(reco.createdAt).format('DD MMM, yyyy')}
                                                </div>
                                            </td>
                                            <td>
                                                <DropdownMenu>
                                                    <DropdownMenuTrigger>
                                                        <motion.i whileHover={{ scale: 1.1 }} class="las la-ellipsis-v text-lg"></motion.i>
                                                    </DropdownMenuTrigger>
                                                    <DropdownMenuContent>
                                                        <div className='bg-white shadow-md rounded-md absolute' style={{ top: '0px', left: '-60px' }}>
                                                            <div>
                                                                <ul className='flex flex-col items-start p-2'>
                                                                    <DropdownMenuItem>
                                                                        <li className='w-40 cursor-pointer rounded-md' onClick={() => {
                                                                            editRecord(reco);
                                                                        }}>
                                                                            <div className='flex items-center text-base'>
                                                                                <i className="las la-pen text-lg"></i>
                                                                                <p className='text-sm font-serif ml-2'>Edit</p>
                                                                            </div>
                                                                        </li>
                                                                    </DropdownMenuItem>
                                                                    <DropdownMenuItem>
                                                                        <li className='w-40 cursor-pointer rounded-md' onClick={() => {
                                                                            if (reco.media.filename === "avatar.png") {
                                                                                deleteRecord(reco._id, false, reco.media.fileurl);
                                                                            } else {
                                                                                deleteRecord(reco._id, true, reco.media.fileurl);
                                                                            }
                                                                        }}>
                                                                            <div className='flex items-center text-base'>
                                                                                <i className="las la-trash text-lg"></i>
                                                                                <p className='text-sm font-serif ml-2'>Delete</p>
                                                                            </div>
                                                                        </li>
                                                                    </DropdownMenuItem>
                                                                </ul>
                                                            </div>
                                                        </div>
                                                    </DropdownMenuContent>
                                                </DropdownMenu>
                                            </td>
                                        </tr>
                                    })
                                }
                                {
                                    records.length === 0 && <tr className="cursor-pointer hover:bg-gray-100">
                                        <td className="px-6 py-4 whitespace-nowrap" colSpan="4">
                                            <div className="text-sm text-red-600 text-center">
                                                No data found.
                                            </div>
                                        </td>
                                    </tr>
                                }
                            </tbody>
                        </table>
                        <div className='flex py-2 px-4 items-center bg-blue-50'>
                            <p className='text-sm font-serif'>Show rows per page</p>
                            <select className='text-sm ml-2 bg-gray-100' name="pageSize" onChange={handleOnChange} value={pageSize}>
                                <option value={10}>10</option>
                                <option value={20}>20</option>
                                <option value={40}>40</option>
                                <option value={50}>50</option>
                            </select>
                            <div className='flex-grow'></div>
                            <p className='text-sm font-serif mr-2'>Page {pageCurrent} of {pageTotal}</p>
                            <div onClick={() => { prevPage() }}><i className={`las la-angle-left w-6 h-6 flex items-center justify-center rounded-full hover:bg-gray-200 ${pageCurrent <= 1 ? 'text-gray-400 cursor-not-allowed' : 'text-black cursor-pointer'}`}></i></div>
                            <div onClick={() => { nextPage() }}><i className={`las la-angle-right w-6 h-6 flex items-center justify-center rounded-full hover:bg-gray-200 ml-2 text-black ${pageCurrent === pageTotal ? 'text-gray-400 cursor-not-allowed' : 'text-black cursor-pointer'}`}></i></div>
                        </div>
                    </div>
                </div>
            </ScrollArea>
        </div>
    )
}
